var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolders(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1004_10386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.092 14.9195L23.6524 8.51742H19.8212L14.024 3.57722C13.772 3.3252 13.4191 3.22437 13.0662 3.22437H3.53863C2.68162 3.22437 2.02637 3.87971 2.02637 4.73663V14.9195H10.092Z",
    fill: "#41EAD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8507 14.9194H45.9843V10.0296C45.9843 9.17259 45.329 8.51733 44.4721 8.51733H38.8262L41.8507 14.9194Z",
    fill: "#41EAD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9603 3.93028C36.557 3.07327 35.4984 2.67005 34.591 3.12373L8.98267 15.2222H42.2534L36.9603 3.93028Z",
    fill: "#007768"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5968 15.1212C47.2943 14.8187 46.891 14.6675 46.4877 14.6675H45.9837H41.85H10.0916H2.02595H1.5219C1.11858 14.6675 0.715351 14.8187 0.41286 15.1212C0.11037 15.4237 -0.0408272 15.8269 0.00953967 16.2302L1.5218 43.6533C1.57217 44.4599 2.22751 45.0648 3.03406 45.0648H44.9754C45.7819 45.0648 46.4373 44.46 46.4876 43.6533L48 16.2302C48 15.8269 47.8488 15.4236 47.5968 15.1212Z",
    fill: "#D1F8F0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1004_10386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolders);
export default __webpack_public_path__ + "static/media/Folders.afe989e722894ced78d68113369fd938.svg";
export { ForwardRef as ReactComponent };